module.exports = __webpack_public_path__ + "img/TXN.41a95c9b.png";